import { render, staticRenderFns } from "./CompanyNewsArticle2.vue?vue&type=template&id=27f3ea3a&scoped=true"
import script from "./CompanyNewsArticle2.vue?vue&type=script&lang=js"
export * from "./CompanyNewsArticle2.vue?vue&type=script&lang=js"
import style0 from "./CompanyNewsArticle2.vue?vue&type=style&index=0&id=27f3ea3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f3ea3a",
  null
  
)

export default component.exports